var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.433,2.3921C10.0994,2.3881 9.8257,2.6535 9.8217,2.9847C9.8185,3.2611 10.0059,3.5038 10.2758,3.5725C12.9651,4.4875 14.9006,7.0187 14.9006,10.0056C14.9006,13.7656 11.8427,16.8008 8.0544,16.8008C4.2662,16.8008 1.2082,13.7656 1.2082,10.0056C1.2082,7.0187 3.144,4.4875 5.8332,3.5725C6.1503,3.4696 6.3235,3.131 6.2198,2.8162C6.1334,2.554 5.8777,2.3839 5.6004,2.4045C5.5464,2.4101 5.4937,2.4227 5.4431,2.4421C2.2758,3.5198 0,6.5037 0,10.0056C0,14.4137 3.6134,18 8.0544,18C12.4955,18 16.1087,14.4137 16.1087,10.0056C16.1087,6.5037 13.8332,3.5198 10.6658,2.4421C10.5923,2.4103 10.5132,2.3933 10.433,2.3921ZM8.0481,0C7.7145,0.0034 7.4469,0.2746 7.4503,0.6058V0.6122V5.4088C7.4457,5.74 7.7123,6.0122 8.0459,6.0168C8.3796,6.0216 8.6538,5.7568 8.6585,5.4258C8.6587,5.42 8.6587,5.4144 8.6585,5.4088V0.6122C8.6655,0.281 8.4007,0.007 8.0671,0.0002C8.0608,0 8.0546,0 8.0481,0Z",
    fill: "#6E6E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.6b83babfd4722fe39547d5f1d694c58e.svg";
export { ForwardRef as ReactComponent };